export const toolTechnologyRequestTypes = [{ label: 'Cấp mới', value: 'provide' }];


export const approverType = {
    approver: 1,
    itlead: 2,
    ithead: 3,
    assignee: 4,
}